export default __webpack_public_path__ + "static/media/single-project-page-01-header-img.fbf6c92f.jpg";